import React, { FunctionComponent, useContext } from "react"
import "../assets/app.css"
import { BrowserRouter } from "react-router-dom"
import { Auth0Provider } from "@auth0/auth0-react"
import { AuthContext } from "../providers/AuthProvider"
import FeedbackBar from "./FeedbackBar"
import Main from "./Main"
import Footer from "./Footer"
import { useServiceWorker } from "../useServiceWorker"
import ConnectivityChecker from "./ConnectivityChecker"
import routes from "../routes"
import useAuth0Config from "../hooks/useAuth0Config"

const SystemMessage: FunctionComponent = ({ children }) => <div className="systemMessage">{children}</div>

const App: FunctionComponent = () => {
    const { Message } = useContext(AuthContext)
    const { showReload, reloadPage, initialised } = useServiceWorker()
    const auth0Config = useAuth0Config()

    const renderMain = () => {
        if (auth0Config.loading) {
            return <div className="loader loader-xl" />
        }

        if (auth0Config.auth0Enabled) {
            const main = (
                <BrowserRouter>
                    <Main auth0Enabled={true} />
                </BrowserRouter>
            )
            return (
                <Auth0Provider
                    domain={auth0Config.domain}
                    clientId={auth0Config.clientId}
                    authorizationParams={{
                        redirect_uri: `${window.location.origin}${routes.AUTH0_CALLBACK}`,
                        audience: auth0Config.audience
                    }}
                >
                    {main}
                </Auth0Provider>
            )
        }

        return (
            <BrowserRouter>
                <Main auth0Enabled={false} />
            </BrowserRouter>
        )
    }

    return (
        <>
            <div className="systemMessages">
                {initialised && <SystemMessage>{Message("offlineUse")}</SystemMessage>}
                {showReload && (
                    <SystemMessage>
                        {Message("newVersionAvailable")} <button onClick={reloadPage}>{Message("updateNow")}</button>
                    </SystemMessage>
                )}
            </div>
            <FeedbackBar />
            <ConnectivityChecker />
            {renderMain()}
            <Footer/>
        </>
    )
}

export default App
